import type { CSSProperties, ReactNode } from "react";
import AnalyticsClicks from "@/components/analytics/AnalyticsClicks";
import Header from "@/components/shared/Header";
import Footer from "@/components/shared/Footer";

/**
 * Page shell for the redesigned site. Wraps content in the `.al` design scope
 * (see the design layer in src/styles/globals.css), pins the header, and renders the footer.
 */
export default function SitePage({ children, className = "" }: { children: ReactNode; className?: string }) {
  return (
    <div className={`al ${className}`.trim()}>
      <div className="sticky top-0 z-50">
        <Header />
      </div>
      <main id="main">{children}</main>
      <Footer />
      <AnalyticsClicks />
    </div>
  );
}

/** Hero band with the grid backdrop and the two animated glows. */
export function PageHero({
  children,
  id,
  className = "",
  style,
  glows = "both",
}: {
  children: ReactNode;
  id?: string;
  className?: string;
  style?: CSSProperties;
  /** Which background glows to render. The resume and products heroes use violet only. */
  glows?: "both" | "violet" | "none";
}) {
  return (
    <section id={id} className={`page-hero ${className}`.trim()} style={style}>
      <div className="hero-grid" aria-hidden="true" />
      {glows !== "none" ? <div className="glow glow-v" aria-hidden="true" /> : null}
      {glows === "both" ? <div className="glow glow-t" aria-hidden="true" /> : null}
      {children}
    </section>
  );
}
